<template>
    <div id="pre-black-content">
        <div class="intro-container">
            <h1 class="mt-0 mb-4">Chico Rei + Black Friday = Promoções exclusivas</h1>
            <div class="section-content mb-7">
                <div class="content-text">
                    <h2 class="my-0">O que é a Black Friday?</h2>
                    <p class="my-3">
                        A <strong>Black Friday</strong> é popularmente conhecida como um dia de
                        promoções que atrai milhares de compradores dos mais diversos segmentos. Com
                        <strong>origem nos EUA</strong>, a data é muito importante para o varejo e
                        acontece logo após o Dia de Ação de Graças. Mas, afinal, como essa data
                        surgiu e qual a ligação dela com o feriado americano?
                    </p>
                    <p class="my-3">
                        Nos EUA é muito comum que o feriado seja emendado, o que deu aos lojistas
                        uma ideia prática e rentável: liquidar todo o estoque durante a folga de boa
                        parte dos trabalhadores, sendo assim, as compras aumentariam, movimentando
                        produtos antigos e abrindo espaço para as novidades de Natal. Eis que surge
                        a <strong>Black Friday</strong>, um dia conhecido pelos
                        <strong>descontos altos</strong> e pelo grande fluxo de compra!
                    </p>
                    <p class="my-3">
                        Agora, trazendo para o cenário nacional, a data só se tornou popular a
                        partir de meados dos anos 2000 e, desde então, ganha mais força a cada ano!
                        Por aqui, como você já sabe, nós somos grandes fãs de um bom desconto e foi
                        pensando nisso que preparamos algumas
                        <strong>promoções exclusivas</strong> para você! Na
                        <strong>Chico Rei</strong> a <strong>Black Friday</strong> começa mais cedo
                        e você está mais do que convidado para essa festa.
                    </p>
                </div>
                <div class="content-image">
                    <img :src="images[0]" />
                </div>
            </div>
            <div class="section-content">
                <div class="content-text">
                    <h2 class="my-0">Quando começa a Black Friday Chico Rei?</h2>
                    <p class="my-3">
                        Por que aproveitar apenas um dia de promoções se nós podemos fazer isso ao
                        longo de todo o mês? A gente sabe que não tem nada melhor do que comprar
                        aquele item com o qual você estava sonhando por um precinho especial. Por
                        isso, durante todo o mês de novembro o
                        <strong>site da Chico Rei</strong> estará com
                        <strong>ofertas exclusivas</strong> que você não pode perder!
                    </p>
                    <p class="my-3">
                        Resumindo em poucas palavras, a <strong>Black Friday</strong> é o momento em
                        que alguns dos nossos produtos estão com os
                        <strong>menores preços do ano</strong>, ou seja, é a chance que você estava
                        esperando para esvaziar seu carrinho! Do lado de cá nós já estamos ansiosos,
                        apenas esperando o seu pedido chegar.
                    </p>
                </div>
                <div class="content-image">
                    <img :src="images[1]" />
                </div>
            </div>
        </div>
        <NewsletterRoberta />
        <div class="tips-container">
            <h2>Dicas para não perder nenhuma promoção da Black Friday</h2>

            <div class="section-content">
                <div class="content-text">
                    <div class="my-3">
                        <h3><strong>Atualize seus dados em nosso site:</strong></h3>
                        <p>
                            Acesse a aba
                            <a href="/minha-conta/meus-dados" target="_blank">“Meus Dados”</a> para
                            conferir se o seu e-mail, número de telefone e endereço estão corretos.
                            Além de atualizar os canais de contato, você também evita imprevistos
                            futuros com a entrega do seu pedido.
                        </p>
                    </div>
                    <div class="my-3">
                        <h3><strong>Escolha os produtos com antecedência:</strong></h3>
                        <p>
                            Entre em nosso site e adicione os seus produtos favoritos na
                            <a href="/minha-conta/wishlist" target="_blank">“Lista de Desejo”</a>.
                            Para isso, basta marcar o item com um coração, selecionando a cor e o
                            tamanho de sua preferência. No dia, ficará muito mais fácil aproveitar
                            as promoções e saber o que comprar.
                        </p>
                    </div>
                    <div class="my-3">
                        <h3>
                            <strong
                                ><a href="/newsletter" target="_blank"
                                    >Cadastre-se na nossa newsletter:</a
                                ></strong
                            >
                        </h3>
                        <p>
                            Ao se cadastrar você fica sabendo de todas as nossas ofertas em primeira
                            mão, além de ter acesso a todos os nossos lançamentos e condições
                            especiais de compra.
                        </p>
                    </div>
                    <div class="my-3">
                        <h3><strong>Fique de olho em nossas redes sociais:</strong></h3>
                        <p>
                            Acompanhe-nos no
                            <a href="https://www.instagram.com/chicorei/" target="_blank"
                                >Instagram</a
                            >,
                            <a href="https://www.facebook.com/chicorei" target="_blank">Facebook</a
                            >, <a href="https://x.com/chicorei" target="_blank">Twitter</a> e receba
                            o melhor da Chico Rei em primeira mão!
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import NewsletterRoberta from './NewsletterRoberta.vue';

    export default {
        name: 'PreBlackBanner',
        components: {
            NewsletterRoberta,
        },
        data() {
            return {
                images: [
                    this.$scope.CDN_IMAGES +
                        '/images/hotsites/blackfriday-2024/BF_Banner_lateral1_LandingPage_PreBF_171024-1.png',
                    this.$scope.CDN_IMAGES +
                        '/images/hotsites/blackfriday-2024/BF_Banner_lateral1_LandingPage_PreBF_171024.png',
                ],
            };
        },
    };
</script>
